// src/app/page-not-found/page-not-found.component.ts

import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-not-found',
    template: `
    <div class="page-not-found">
      <h2>404 - Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
      <a routerLink="/">Go to Home</a>
    </div>
  `,
    styles: [`
    .page-not-found {
      text-align: center;
      margin-top: 50px;
    }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent { }
